import { useQueryClient } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';
import { useThrottledMutation as useMutation } from '@hooks/use-throttled-mutation';
import { useScopedTranslate } from '@locale/translate';

import { createManualReminder } from './requests';

export const useCreateManualReminder = () => {
  const { t } = useScopedTranslate(locale);
  const { showSuccess } = useToaster();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createManualReminder,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['traveller-action', data.travellerAction]);
      showSuccess(t('manualReminderCreated'));
    },
  });
};

const locale = {
  en: {
    manualReminderCreated: 'Manual reminder created',
  },
};
